import TableContainer from '../Common/CTable/containers/TableContainer';
import { AdminManageDataTypes } from '@typedef/components/AdminManage/adminManage.data.types';
import { TableColumnTypes } from '@typedef/components/Common/CTable/table.column.type';
import * as S from '@styles/PresenterStyle';
import CSearchContainer from '@components/Common/CSearch/containers/CSearchContainer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { RefObject } from 'react';

type Props = {
  columns: TableColumnTypes[];
  tableData: AdminManageDataTypes[];
  manage: (type: 'insert' | 'update') => void;
  deleteAdminData: () => Promise<void>;
  searchTable: () => void;
  searchValue: string | null;
  inputRef: RefObject<HTMLInputElement>;
  clearSearchValue: () => void;
};

const AdminManage = ({
  columns,
  tableData,
  manage,
  deleteAdminData,
  searchTable,
  searchValue,
  inputRef,
  clearSearchValue,
}: Props) => {
  return (
    <S.Presenter>
      <S.TitleBox>
        <h2>관리자관리</h2>
        <S.Btns>
          <S.Btn onClick={() => manage('insert')} className='active'>
            등록
          </S.Btn>
          <S.Btn onClick={() => manage('update')}>수정</S.Btn>
          <S.Btn onClick={deleteAdminData}>삭제</S.Btn>
        </S.Btns>
      </S.TitleBox>
      <S.FilterBox>
        <CSearchContainer func={searchTable} inputRef={inputRef} />
        <div className='apply'>
          {searchValue && (
            <S.SearchValue>
              <p>{searchValue}</p>
              <button type='button' onClick={clearSearchValue}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </S.SearchValue>
          )}
        </div>
      </S.FilterBox>
      <TableContainer
        columns={columns}
        tableData={tableData}
        searchValue={searchValue}
      />
    </S.Presenter>
  );
};

export default AdminManage;
